export const UPDATE_NOW = 'UPDATE_NOW';

export const SELECT_CHANNEL_CARD_SET = 'SELECT_CHANNEL_CARD_SET';
export const SELECT_STORE_CATEGORIES = 'SELECT_STORE_CATEGORIES';
export const SELECT_COMMUNITY_FILTERS = 'SELECT_COMMUNITY_FILTERS';

export const TOGGLE_IMAGE_VIEWER = 'TOGGLE_IMAGE_VIEWER';
export const TOGGLE_VISIT_DIALOG = 'TOGGLE_VISIT_DIALOG';
export const TOGGLE_ALARM_DIALOG = 'TOGGLE_ALARM_DIALOG';

export const CLICK_SUBSCRIPTION_TAB = 'CLICK_SUBSCRIPTION_TAB';

export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

export const SELECT_TIME_INVALID = 'SELECT_TIME_INVALID';
